var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComingSoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 900,
    viewBox: "0 0 600 900",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "Image coming soon placeholder",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 0,
    x2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#e0e7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#f8fafc"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "url(#g)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(40,80)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 520,
    height: 740,
    rx: 12,
    fill: "#fff",
    stroke: "#d1d5db",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,24)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 24,
    width: 472,
    height: 420,
    rx: 8,
    fill: "#f3f4f6",
    stroke: "#e5e7eb"
  }), /*#__PURE__*/React.createElement("text", {
    x: "50%",
    y: 260,
    dominantBaseline: "middle",
    textAnchor: "middle",
    fill: "#9ca3af",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 22
  }, "Image"), /*#__PURE__*/React.createElement("text", {
    x: "50%",
    y: 290,
    dominantBaseline: "middle",
    textAnchor: "middle",
    fill: "#9ca3af",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 18
  }, "coming soon")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32,480)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 520,
    height: 200,
    rx: 6,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 28,
    fill: "#374151",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 20
  }, "Preview image"), /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 56,
    fill: "#6b7280",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 14
  }, "This image is a local placeholder used when"), /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 76,
    fill: "#6b7280",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 14
  }, "no valid remote image URL is provided.")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComingSoon);
export default __webpack_public_path__ + "static/media/coming-soon.0cae00abb2098ea08854d009bb1d2755.svg";
export { ForwardRef as ReactComponent };